/**
 * Copies a public share link for a list to the clipboard.
 */
import { useMutation } from "@tanstack/react-query";
import { Link2 } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { listsService } from "../services/lists.service";

export const shareUrlForToken = (token: string) => `${window.location.origin}/lists/${token}`;

export function ShareListButton({ listId }: { listId: string }) {
  const share = useMutation({
    mutationFn: async () => {
      const { token } = await listsService.shareList(listId);
      const url = shareUrlForToken(token);
      try {
        await navigator.clipboard.writeText(url);
        toast.success("Link copied. Anyone with it can view this list.");
      } catch {
        toast(url, { description: "Copy this link to share the list.", duration: 15000 });
      }
    },
    onError: () => toast.error("Could not create a share link. Please try again."),
  });

  return (
    <Button variant="outline" onClick={() => share.mutate()} disabled={share.isPending}>
      <Link2 aria-hidden /> Share
    </Button>
  );
}
